import React from 'react';
import { Section } from './ui/Section';
export function Authority() {
  const flow = [{
    label: 'Plato tradicional',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e5fc5124-93ef-444b-a413-4c5df04d17c9.jpg'
  }, {
    label: 'Sustitución inteligente',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3a25dafb-b4b5-481b-a24c-ac82087a50eb.jpg'
  }, {
    label: 'Resultado recreado',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/aa63e646-02f9-4ea7-b435-be5881cae257.jpg'
  }];
  return <Section variant="alt" data-id="element-20" data-mp="hf5zvs1b2lbv">
      <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-21" data-mp="m7pd2nw2zeg5">
        <h2 className="font-display text-2xl md:text-4xl font-bold text-brand-title leading-tight mb-4" data-id="element-22" data-mp="m88wya5akcwt">
          ¿Y si no tuvieras que renunciar al plato… sino cambiar cómo lo
          construyes?
        </h2>
        <p className="text-brand-primary font-heading italic text-lg" data-id="element-23" data-mp="va8csz4klay6">
          Ahí nace el Mimetismo Nutricional™.
        </p>
      </div>

      <div className="max-w-3xl mx-auto flex items-start justify-center gap-1.5 md:gap-3" data-id="element-24" data-mp="ffjbhkfwkj43">
        {flow.map((step, i) => <React.Fragment key={i} data-id="element-25" data-mp="agf48zcjgvge" data-mpi={i}>
            <div className="flex flex-col items-center flex-1 min-w-0" data-id="element-26" data-mp="afdh3wi90iib">
              <div className="w-full aspect-square rounded-2xl overflow-hidden shadow-card mb-3 border border-brand-border" data-id="element-27" data-mp="6g4o4tv18ont">
                <img src={step.img} alt={step.label} className="w-full h-full object-cover" loading="lazy" data-id="element-28" data-mp="1hutckd7zq2q" />
              </div>
              <span className="text-[10px] md:text-sm font-heading font-bold text-brand-title uppercase tracking-wide text-center leading-snug" data-id="element-29" data-mp="u4nwf9e311fw">
                {step.label}
              </span>
            </div>
            {i < flow.length - 1 && <span className="text-brand-secondary text-lg md:text-2xl font-bold shrink-0 mt-6 md:mt-8" data-id="element-30" data-mp="kfnt5dsjrjvw">
                →
              </span>}
          </React.Fragment>)}
      </div>
    </Section>;
}